var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-text",attrs:{"id":"NoNotifications"}},[_vm._v("No Notifications to show")])
}
var staticRenderFns = []

export { render, staticRenderFns }